import React, { useState, useEffect } from "react";
import Papa from "papaparse";
import { Crud_Catalogos } from '../../herramientas/Crud_Catalogos';
import Select from "react-select";
import { LoadingScreen } from "../../components/LoadingScreen";
import SiteWrapper from "../../SiteWrapper.react";

//import "./App.css";
 
const allowedExtensions = ["csv"];

const TerminadoMasivo = () => {
    // This state will store the parsed data
    const [data, setData] = useState([]);
    const [error, setError] = useState("");
    const [file, setFile] = useState("");
    const [plataforma, setPlataforma] = useState(null);
    const [plataformas, setPlataformas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [resultado, setResultado] = useState(null);
    const [ids,setIds] = useState("");

    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem("usuario"));
        if (user && user.id) {
            Crud_Catalogos("plataformasUsuariosPerfiles/idUsuario/" + user.id, "", "get", "", [], "", "", "", []).then((data) => {
                if (data) {
                    const opts = data.map((p) => ({ value: String(p.plataforma.id), label: p.plataforma.nombre }));
                    setPlataformas(opts);
                    if (opts.length > 0) setPlataforma(opts[0].value);
                }
            }).catch((err) => console.error("Error cargando plataformas:", err));
        }
    }, []);

    useEffect(() => {
        if(ids && plataforma) {
        setLoading(true);
        setResultado(null);
        getfuntion("get", [], "", "terrestreMovimientos/terminarMovimientosMasiv/"+plataforma+"/"+ids, "")
          .then((res) => setResultado(res))
          .finally(() => setLoading(false));
        }
    },[ids,plataforma]);

    const handleFileChange = (e) => {
        setError("");
 
        // Check if user has entered the file
        if (e.target.files.length) {
            const inputFile = e.target.files[0];
            const fileExtension =inputFile?.type.split("/")[1];
            if (
                !allowedExtensions.includes(fileExtension)
            ) {
                setError("Ese archivo no es válido. Introduzca un .csv !!!");
                return;
            }
            
            // If input type is correct set the state
            setFile(inputFile);
        }
    };
    const handleParse = () => {
        if (!file) return alert("El archivo no es csv");        
        let reader = new FileReader();
        reader.onload = async ({ target }) => {
            const csv = Papa.parse(target.result, {
                header: true,
            });
            const parsedData = csv?.data;
            const rows = Object.keys(parsedData[0]);
            const columns = Object.values(parsedData[0]);
            const res = rows.reduce((acc, e, i) => {
                return [...acc, [[e], columns[i]]];
            }, []);
            const stringData = parsedData.reduce((result, item) => {
              return `${result}${item.id},`
            }, "")  
            setIds(stringData);
             setData(res);
        };
        reader.readAsText(file);
    };
 
    const getfuntion = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {
      return Crud_Catalogos(catalogo, "movimientos", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
        //setTrackPoints({ returnVal });
        switch (metodo) {
          case "get":
            {
              switch (stateVar) {
  
                default: return returnVal;
              }
            }
        }
      })
    }

    return (
        <SiteWrapper>
        <div className="App">
            <div className="container">

            <h1 className="geeks">Terminado Masivo de Movimientos Terrestres</h1>
            <h3>Para movimientos de la Plataforma seleccionada</h3>

            <div style={{width: '300px'}}>

            <Select
            onChange={(plataforma) => {
                setPlataforma(plataforma.value);
                //alert(plataforma.value);
            }}
            //options={bloques}
            options={plataformas}
            hideSelectedOptions
            //value={plataforma}
          />
            </div>


                <label
                    htmlFor="csvInput"
                    style={{ display: "block" }}
                >
                    Ingrese CSV
                </label>
                <input
                    onChange={handleFileChange}
                    id="csvInput"
                    name="file"
                    type="File"
                />
                <div><br/>
                    <button onClick={handleParse} disabled={loading}>
                        Subir
                    </button>
                </div>
                {loading && <LoadingScreen loading={true} mensaje="Procesando movimientos..." />}
                {!loading && resultado !== null && <div style={{ marginTop: "1rem", color: "green" }}>✅ {resultado} movimientos procesados correctamente</div>}
                {/* <div style={{ marginTop: "3rem" }}>
                   {ids}
                </div> */}
            </div>
        </div>
        </SiteWrapper>
    );
};

export default TerminadoMasivo;